<!-- pc端开窗 -->
<div class="fx_modal_container fx-search-modal_container" #layout appModalDrag [hidden]="fxMedia == 'mobile'">
    <!-- 标题栏 -->
    <div class="fx_modal_title mb-3">
        <div class="fx_le_title">
            <i class="anticon anticon-credit-card"></i>
            <span>{{title}}</span>
        </div>
        <div class="fx_ri_full d-flex align-items-center">
            <ul class="mb-0">
                <li class="fx_modal_search">
                    <dw-input-group [dwSuffix]="suffixIconButton" dwSearch>
                        <input type="text" dw-input placeholder="请输入筛选条件" [(ngModel)]="_searchText"
                            (keyup)="($event.which === 13)?search():0" #searchBox>
                    </dw-input-group>
                    <ng-template #suffixIconButton>
                        <button dw-button dwType="default" dwSearch (click)="search()" class="searchBtn"><i
                                class="anticon anticon-search"></i></button>
                    </ng-template>
                </li>
                <li>
                    <ol class="fx_modal_icon-group ps-2">
                        <!-- 是否显示进阶查询 -->
                        <li *ngIf="isBackendPaging">
                            <i class="anticon" (click)="isMoreConShow = !isMoreConShow"
                                [ngClass]="{'anticon-up': isMoreConShow, 'anticon-down': !isMoreConShow}"></i>
                        </li>
                        <!-- 清空 -->
                        <li>
                            <i class="anticon anticon-reload" title="{{'comm-清除' | translate}}"
                                (click)="cleanSearchParam()"></i>
                        </li>
                        <!-- 最大最小化 -->
                        <li>
                            <i class="anticon anticon-arrows-alt fullBtn"
                                title="{{iconFull ? ('comm-缩小' | translate) : ('comm-放大' | translate)}}"
                                (click)="fullModal(isParm)" [ngClass]="{'anticon-shrink': isFull}"></i>
                        </li>
                        <!-- 关闭 -->
                        <li *ngIf="!isRequired">
                            <i class="anticon anticon-close fx_modal_close_btn" title="{{'comm-关闭' | translate}}"
                                (click)="fxCloseModal()"></i>
                        </li>
                    </ol>
                </li>
            </ul>
        </div>
    </div>
    <div dw-row class="fx-modal-content fx-modal-more-comcond" [hidden]="isMoreConShow == false">
        <more-comcond #moreComcond [hidden]="isMoreConShow == false" [searchData]="searchlableList"
            (onSearch)="search()"></more-comcond>
    </div>
    <!--<div dw-row class="fx-modal-content">-->
    <!--<dw-col dwSpan="15">-->
    <!--<button dw-button [dwType]="'default'" (click)="debug()">DEBUG</button>-->
    <!--</dw-col>-->
    <!--&lt;!&ndash;<dw-col dwSpan="9" [dwPush]="15">&ndash;&gt;-->
    <!--<dw-col dwSpan="9" >-->
    <!--<dw-input-group dwSuffixIcon="anticon anticon-search">-->
    <!--<input type="text" dw-input placeholder="请输入筛选条件" [(ngModel)]="_searchText" (keyup)="($event.which === 13)?search():0">-->
    <!--</dw-input-group>-->
    <!--</dw-col>-->
    <!--</div>-->
    <!-- 显示区域 -->
    <dw-row class="fx_modal_content p-0" [style.height]="isHeight">
        <!-- <ag-grid-angular [rowHeight]="34"#masterGrid style="height:calc(100vh - 143px)"
        [rowData]="this.MasterService.masterDataSet$|async" [gridOptions]="masterGridOptions"
        [deltaRowDataMode]="false" [getRowNodeId]="getRowNodeId" [animateRows]="false" class="ag-theme-balham"
        [columnDefs]="masterColumnDefs" [frameworkComponents]="frameworkComponents" [enableSorting]="true"
        [pagination]="false" [paginationPageSize]="searchParam.pageSize" [editType]="'fullRow'"
        [enableColResize]="true" defaultColDef="{ width: 100 }" [localeTextFunc]="localTextFunc"
        (gridReady)="onMasterGridReady($event)" (selectionChanged)="onMaserSelectionChanged($event)"
        [rowSelection]="'multiple'" [suppressRowClickSelection]="true" [suppressCellSelection]="true">
    </ag-grid-angular> -->
        <ag-grid-angular [rowHeight]="34" [headerHeight]="44" #masterGrid style="width: 100%; height: 100%;"
            id="masterGrid" [rowData]="_displyData" class="ag-theme-balham" [defaultColDef]="_defaultColDef"
            [context]="context" [columnDefs]="_columnDefs" [components]="_components"
            [frameworkComponents]="frameworkComponents" [enableSorting]="false" [pagination]="true"
            [suppressPaginationPanel]="true" [paginationPageSize]="_pageSize" [rowSelection]="_rowSelection"
            [rowMultiSelectWithClick]="true" [editType]="false" [enableFilter]="false" [floatingFilter]="false"
            [enableColResize]="true" rowSelection="multiple" defaultColDef="{ width: 100 }" [rowBuffer]="50"
            (gridReady)="onGridReady($event)" (selectionChanged)="selectionChanged($event)"></ag-grid-angular>

    </dw-row>

    <dw-row class="fx_modal_footer p-0 pt-4">
        <div dw-col [dwSpan]="12" style="display: flex;">
            <dw-pagination [dwPageIndex]="_pageNumber" [dwTotal]="_rowCount" dwShowSizeChanger dwShowQuickJumper
                [(dwPageSize)]="_pageSize" [dwSize]="'small'" (dwPageIndexChange)="onPageIndexChange($event)"
                (dwPageSizeChange)="onPageSizeChange()" [dwPageSizeOptions]="pageSizeOption"></dw-pagination>
        </div>
        <div dw-col [dwSpan]="12">
            <!-- class="btn border-danger bg-danger text-white" -->
            <div dw-row dwType="flex" dwJustify="end" class="ant-modal-footer pb-0">
                <button *ngIf="!isRequired" dw-button class="fx-width-70px" [dwType]="'default'" (click)="onClickCancel()">取消</button>
                <button dw-button [dwType]="'primary'" (click)="onClickOK()">确定</button>
            </div>
        </div>
    </dw-row>
</div>

<!-- 移动端开窗 -->
<div class="position-fixed start-0 end-0 min-vh-100" *ngIf="fxMedia == 'mobile'">
    <!-- 搜索框 -->
    <div class="fixed-top p-16px bg-color fx-search-pannel">
        <div class="d-flex flex-row align-items-center">
            <div class="flex-fill">
                <form class="d-flex rounded-pill align-items-center px-2 rounded bg-white" role="search">
                    <label for="nav-input"><i class="anticon anticon-search"></i></label>
                    <input class="form-control me-2 border-0" type="timt"
                        placeholder="{{'fxed020-请输入筛选条件' | translate}}" aria-label="Search" id="glikesel"
                        (change)="openPage($event.target.value)">
                </form>
            </div>
        </div>
    </div>
    <!-- 列表查询 -->
    <div class="list-group border-radius-0 position-absolute start-0 bottom-0 bg-white end-0 top-0" >
        <div class="list-group-item list-group-item-action d-flex flex-column px-6px py-12px" *ngFor="let item of _displyData" (click)="onItemClick(item)">
            <div *ngIf="postParam.modalID != 'qry_eabseq_6'">
                <div *ngIf="name">{{item[name]}}</div>
                <div class="text-secondary" *ngIf="id">{{item[id]}}</div>
            </div>
            <div *ngIf="postParam.modalID == 'qry_eabseq_6'">
                <span>{{item.eabgoods_n1}}</span>
                <div class="text-secondary d-flex justify-content-between">
                    <span>{{item.eabgoods}}</span>
                    <span>订单项次：{{item.eabseq}}</span>
                </div>
                <div class="text-secondary d-flex justify-content-between">
                    <span>{{item.eabgchr_n1}}</span>
                    <span>可退货数量：{{item.thqty}}</span>
                </div>
            </div>
        </div>
    </div>
    <dw-row class="fx_modal_footer" *ngIf="_rowSelection == 'multiple'">
        <div dw-col [dwSpan]="18" style="display: flex;">
            <dw-pagination [dwPageIndex]="_pageNumber" [dwTotal]="_rowCount" dwShowSizeChanger dwShowQuickJumper
                [(dwPageSize)]="_pageSize" [dwSize]="'small'" (dwPageIndexChange)="onPageIndexChange($event)"
                (dwPageSizeChange)="onPageSizeChange()" [dwPageSizeOptions]="pageSizeOption"></dw-pagination>
        </div>
        <div dw-col [dwSpan]="6">
            <div dw-row dwType="flex" dwJustify="end">
                <button *ngIf="!isRequired" dw-button [dwType]="'default'" (click)="onClickCancel()">取消</button>
                <button dw-button [dwType]="'primary'" (click)="onClickOK()">确定</button>
            </div>
        </div>
    </dw-row>
</div>
